const SCOPE = 'platform-group'

// Stored in sessionStorage (not localStorage) — cleared on the next page load after logout
export const JUST_LOGGED_OUT_KEY = `${SCOPE}/irwin/just-logged-out`
// Set when Auth0 token expires, cleared after the interstitial is shown
export const JUST_SESSION_EXPIRED_KEY = `${SCOPE}/irwin/just-session-expired`
// Set when getAccessTokenSilently fails for FactSet users (initial login or page refresh after logout)
export const NEEDS_FACTSET_LOGIN_KEY = `${SCOPE}/irwin/needs-factset-login`
